function useAvatarBadge(userName, userIsEmployee, userIsManagingEditor) {
  let avatarTooltip = userName;
  let avatarBadge = '';
  let avatarBadgeColor = 'blue.primary';

  if (userIsEmployee) {
    avatarTooltip = `${userName} - Contently employee`;
    avatarBadge = 'C';
  }
  if (userIsManagingEditor) {
    avatarTooltip = `${userName} - Contently managing editor`;
    avatarBadge = 'ME';
    avatarBadgeColor = 'grey.primary';
  }

  return [avatarTooltip, avatarBadge, avatarBadgeColor];
}

export default useAvatarBadge;



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useAvatarBadge.js